import dayjs from 'dayjs'
const datesGenerator = () => {
  const TimeRanges = {
    lastWeek: 0,
    lastMonth: 1,
    last6Monts: 2,
    lastYear: 3
  }
  const getThisWeekStartDate = () => {
    const today = new Date()
    const sevenDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6)
    sevenDaysAgo.setHours(0, 0, 0, 0)
    return sevenDaysAgo
  }

  const getThisMonthStartDate = () => {
    const today = new Date()
    const aMonthAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30)
    aMonthAgo.setHours(0, 0, 0, 0)
    return aMonthAgo
  }

  const getHalfYearStartDate = () => {
    const today = new Date()
    const currentWeekday = today.getDay()
    const endOfWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (7 - currentWeekday))
    const sixMonthsAgo = new Date(endOfWeek.getFullYear(), endOfWeek.getMonth(), endOfWeek.getDate() - 182)
    sixMonthsAgo.setHours(0, 0, 0, 0)
    return sixMonthsAgo
  }

  const getYearStartDate = () => {
    const today = new Date()
    const dateIn12MonthsAgo = new Date(today.getFullYear(), today.getMonth() - 11, today.getDate())
    const startOfMonth = new Date(dateIn12MonthsAgo.getFullYear(), dateIn12MonthsAgo.getMonth(), 1)
    startOfMonth.setHours(0, 0, 0, 0)
    return startOfMonth
  }

  const getPastWeekDaysArray = () => {
    const today = new Date()
    let daysOfTheWeek = []

    const todayWeekday = today.getDay()

    for (let i = 0; i <= 6; i++) {
      const day = new Date(today)
      day.setDate(today.getDate() - i)
      const dateFormatter = new Intl.DateTimeFormat('en-US', { weekday: 'short' })
      const dayString = dateFormatter.format(day)
      if (todayWeekday - i <= 0) {
        daysOfTheWeek.push(dayString)
        continue
      }

      daysOfTheWeek.push(dayString)
    }
    daysOfTheWeek = daysOfTheWeek.reverse()
    const dateFormatter = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
    let datesArray = []

    for (let i = 0; i <= 6; i++) {
      const day = new Date(today)
      day.setDate(today.getDate() - i)
      const dateString = dateFormatter.format(day)
      datesArray.push(dateString)
    }
    datesArray = datesArray.reverse()

    return { daysOfTheWeek, datesArray }
  }

  const getPastMonthDaysArray = () => {
    const today = new Date()
    const dateFormatter = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })

    const datesArray = []

    for (let i = 0; i <= 30; i++) {
      const date = new Date(today)
      date.setDate(today.getDate() - i)
      const dateString = dateFormatter.format(date)
      datesArray.push(dateString)
    }

    return datesArray.reverse()
  }

  const getPast12Months = () => {
    const calendar = new Date()

    const dateFormatter = new Intl.DateTimeFormat('en-US', { month: 'long' })

    const monthsArray = []

    for (let i = 0; i < 12; i++) {
      const date = new Date(calendar.getFullYear(), calendar.getMonth() - i, 1)
      const monthString = dateFormatter.format(date)
      monthsArray.push(monthString)
    }
    monthsArray.reverse()

    return monthsArray
  }

  function getHalfYearWeeksArray () {
    const today = new Date()
    const endDate = dayjs(today).endOf('week')

    const descriptions = []

    let currentDate = dayjs(today).subtract(25, 'week').startOf('week')
    while (currentDate <= endDate) {
      const startOfWeek = currentDate.format('MM/DD/YYYY')
      const endOfWeek = currentDate.add(6, 'day').format('MM/DD/YYYY')
      const description = `${startOfWeek} - ${endOfWeek}`
      descriptions.push(description)
      currentDate = currentDate.add(1, 'week')
    }

    return descriptions
  }

  const convertTimeStampToDateString = (timestamp) => {
    const date = timestamp.toDate()

    let month = date.getMonth() + 1 // Add 1 to get the month in the 1-12 range
    let day = date.getDate()
    const year = date.getFullYear()

    // Pad the month and day with leading zeros if necessary
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }

    const dateString = `${month}/${day}/${year}`
    return dateString
  }

  const getMonthNameFromDate = (dateString) => {
    const [month, day, year] = dateString.split('/')
    const date = new Date(year, month - 1, day)

    const dateFormatter = new Intl.DateTimeFormat('en-US', { month: 'long' })
    return dateFormatter.format(date)
  }

  function getWeekRangeForDate (dateString) {
    const date = dayjs(dateString, 'MM/DD/YYYY')
    const startOfWeek = date.startOf('week').format('MM/DD/YYYY')
    const endOfWeek = date.endOf('week').format('MM/DD/YYYY')
    return `${startOfWeek} - ${endOfWeek}`
  }

  return {
    TimeRanges,
    getThisWeekStartDate,
    getThisMonthStartDate,
    getHalfYearStartDate,
    getYearStartDate,
    getPastWeekDaysArray,
    getPastMonthDaysArray,
    convertTimeStampToDateString,
    getPast12Months,
    getMonthNameFromDate,
    getHalfYearWeeksArray,
    getWeekRangeForDate
  }
}

export default datesGenerator
